// Brand assets used across the app
export const MONETISEUP_LOGO = "/assets/monetiseup-logo.svg";

export const XYLE_LOGO = "/assets/xyle-logo.svg";

export const PARTNERS = [
  { name: "Google", domain: "google.com" },
  { name: "Taboola", domain: "taboola.com" },
  { name: "MGID", domain: "mgid.com" },
  { name: "Outbrain", domain: "outbrain.com" },
  { name: "OpenX", domain: "openx.com" },
  { name: "Pocket FM", domain: "pocketfm.com" },
  { name: "WebMD", domain: "webmd.com" },
  { name: "Fandom", domain: "fandom.com" },
  { name: "Marca", domain: "marca.com" },
];

export const EXTERNAL = {
  dashboard: "https://dash.monetiseup.tech",
  signup: "/signup",
  manga: "/manga",
  demo: "/demo",
  email: "contact@monetiseup.com",
};
